<ng-template #modal>
    <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalLabel">
            Filter EDI Files
        </h1>
        <button (click)="onClose()" type="button" class="btn-close" aria-label="Close"></button>
    </div>

    <form (ngSubmit)="onSubmit()" [formGroup]="formGroup" autocomplete="off">
        <div class="modal-body container-fluid">
            <div class="row g-1">
                <div class="form-floating col-md-12 mt-3 vm-pe-1">
                    <input class="form-control" formControlName="fileName" id="fileNameControl" type="text"/>
                    <label class="form-label" for="fileNameControl">File Name</label>
                </div>

                <div class="form-floating col-md-12 mt-3">
                    <div class="form-check form-check-inline form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="hasMaintenanceIssueControl" formControlName="hasMaintenanceIssue">
                        <label class="form-check-label" for="hasMaintenanceIssueControl">Maintenance Issues Only</label>
                    </div>
                </div>

                <div class="form-floating col-md-6 mt-3">
                    <div class="input-group">
                        <i class="bi bi-calendar vm-icon input-group-text" (click)="rptStart.toggle()"></i>
                        <div class="form-floating">
                            <input (click)="rptStart.toggle()" type="text" class="form-control" id="reportingStartControl"
                                   formControlName="reportingStartDate" ngbDatepicker #rptStart="ngbDatepicker">
                            <label for="reportingStartControl" class="form-label">Reporting Start Date</label>
                        </div>
                    </div>
                </div>
                <div class="form-floating col-md-6 mt-3 vm-pe-1">
                    <div class="input-group">
                        <i class="bi bi-calendar vm-icon input-group-text" (click)="rptEnd.toggle()"></i>
                        <div class="form-floating">
                            <input (click)="rptEnd.toggle()" type="text" class="form-control" id="reportingEndControl"
                                   formControlName="reportingEndDate" ngbDatepicker #rptEnd="ngbDatepicker">
                            <label for="reportingStartControl" class="form-label">Reporting End Date</label>
                        </div>
                    </div>
                </div>

                <div class="form-floating col-md-6 mt-3">
                    <div class="input-group">
                        <i class="bi bi-calendar vm-icon input-group-text" (click)="loadStart.toggle()"></i>
                        <div class="form-floating">
                            <input (click)="loadStart.toggle()" type="text" class="form-control" id="loadStartControl"
                                   formControlName="loadStartDate" ngbDatepicker #loadStart="ngbDatepicker">
                            <label for="loadStartControl" class="form-label">Load Start Date</label>
                        </div>
                    </div>
                </div>
                <div class="form-floating col-md-6 mt-3">
                    <div class="input-group">
                        <i class="bi bi-calendar vm-icon input-group-text" (click)="loadEnd.toggle()"></i>
                        <div class="form-floating">
                            <input (click)="loadEnd.toggle()" type="text" class="form-control" id="loadEndControl"
                                   formControlName="loadEndDate" ngbDatepicker #loadEnd="ngbDatepicker">
                            <label for="loadEndControl" class="form-label">Load End Date</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button (click)="onReset()" [ngClass]="{ 'd-inline': isFilterApplied(), 'd-none': !isFilterApplied() }"
                    class="btn btn-secondary"
                    type="button">
                Reset Filter
            </button>
            <button [disabled]="savingData" class="btn btn-primary" type="submit">
                @if (savingData) {
                    <span class="spinner-border spinner-border-sm me-1"></span>
                }
                Apply
            </button>
        </div>
    </form>
</ng-template>
